export default "__VITE_ASSET__Dny1wGLA__"